import { useMutation } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function useArInvoiceEmail() {
  const sendMutation = useMutation(
    orpc.accountsReceivable.arInvoiceEmail.send.mutationOptions(),
  );

  const previewMutation = useMutation(
    orpc.accountsReceivable.arInvoiceEmail.preview.mutationOptions(),
  );

  return {
    send: sendMutation.mutateAsync,
    isSending: sendMutation.isPending,
    preview: previewMutation.mutateAsync,
    isPreviewing: previewMutation.isPending,
    previewData: previewMutation.data ?? null,
  };
}
